import { Moon, Sun, Monitor } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useEchoHireTheme } from '@/theme/ThemeProvider';
import { cn } from '@/lib/utils';

const options = [
  { value: 'light', label: 'Light', icon: Sun },
  { value: 'dark', label: 'Dark', icon: Moon },
  { value: 'system', label: 'System', icon: Monitor },
];

/**
 * Theme switcher — use in Settings, admin header, or sidebar footer.
 */
export default function ThemeToggle({ size = 'medium' }) {
  const { mode, resolvedMode, setMode } = useEchoHireTheme();
  const ActiveIcon = resolvedMode === 'dark' ? Moon : Sun;
  const compact = size === 'small';

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size={compact ? 'icon' : 'default'}
          className={cn(
            compact && 'h-9 w-9 shrink-0',
            'border-border bg-background/90 text-foreground shadow-sm backdrop-blur-sm',
            'hover:bg-muted hover:text-foreground dark:border-brand-700/50 dark:bg-brand-950/70 dark:hover:bg-brand-900 dark:hover:text-brand-50'
          )}
          aria-label="Change color theme"
          title="Appearance"
        >
          <ActiveIcon className="h-4 w-4" aria-hidden />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44">
        {options.map((opt) => {
          const Icon = opt.icon;
          return (
            <DropdownMenuItem
              key={opt.value}
              onClick={() => setMode(opt.value)}
              className={cn(
                'cursor-pointer',
                mode === opt.value && 'bg-primary/15 font-medium text-foreground dark:bg-primary/25 dark:text-brand-50'
              )}
            >
              <Icon className="mr-2 h-4 w-4" aria-hidden />
              {opt.label}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
